import { render, staticRenderFns } from "./Monaco.vue?vue&type=template&id=77d5ad30&"
import script from "./Monaco.vue?vue&type=script&lang=js&"
export * from "./Monaco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/fxy/Documents/DCloud/GitHub/CLI-for-Apache-Weex/packages/@weex/plugins/debug/frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('77d5ad30', component.options)
    } else {
      api.reload('77d5ad30', component.options)
    }
    module.hot.accept("./Monaco.vue?vue&type=template&id=77d5ad30&", function () {
      api.rerender('77d5ad30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/vue-monaco-editor/src/Monaco.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-monaco-editor/src/Monaco.vue
// module id = ./node_modules/vue-monaco-editor/src/Monaco.vue
// module chunks = 1